import type { StoreType } from '.';

// Stable reference for the empty fallback so useSelector never sees a fresh object.
// Defensive: the reducer always keeps `data` populated, so this branch is
// unreachable today — it guards against a future change that clears `data`.
const EMPTY_AI_FILTER_VALUES = {
	schoolTypes: [],
	subjects: [],
	classYears: [],
};

export const selectAiFilterValues = (state: StoreType) =>
	state.aiFilterValues.data || EMPTY_AI_FILTER_VALUES;

export const selectAiFilterValuesLoadingStatus = (state: StoreType) => state.aiFilterValues.status;
